/**
 * @classdesc Canvas, auf dem Hilfslinien gezeichnet werden
 * @class
 * @param {OwayoKonfiPart}   parent
 */
import {OwayoKonfiPart} from "./owayoPartWithSelObs";
import {THREE} from "./resource/BVH.js";
import {Vector2} from "./delme_globals";
import {CONSTANTS} from "./meta_data";

export class UtilityPlane {
    textureCanvas : HTMLCanvasElement;
    textureContext2D : CanvasRenderingContext2D;
    texture : THREE.Texture;
    textureSize : Vector2;
    parent : OwayoKonfiPart;
    anzMatrices = 0;
    anzVerticalLines = 0;
    anzHorizontalLines = 0;
    anzRectangles = 0;
    matrices : THREE.Matrix3[] = [];
    horizontalLines : THREE.Vector3[] = [];
    verticalLines : THREE.Vector3[] = [];
    rectangles : THREE.Vector4[] = [];
    rectangleColors : number[] = [];

    constructor(parent : OwayoKonfiPart) {

        this.textureCanvas = document.createElement('canvas');
        this.textureCanvas.width = parent.textureSize.x;
        this.textureCanvas.height = parent.textureSize.y;
        this.textureContext2D = this.textureCanvas.getContext('2d') as CanvasRenderingContext2D;

        this.texture = new THREE.Texture(this.textureCanvas);
        this.texture.minFilter = THREE.LinearFilter;
        this.texture.generateMipmaps = false;

        this.textureSize = new Vector2(parent.textureSize.x, parent.textureSize.y);

        this.parent = parent;

        this.fillMatrixAndLineArraysWithZeroValues();

        this.textureContext2D.strokeStyle = CONSTANTS.HELPER_COLOR;
        this.texture.needsUpdate = true; //benötigt, da sonst schwarz initialisiert!
    }


    private fillMatrixAndLineArraysWithZeroValues() {
        let i;
        this.anzMatrices = 0;
        this.anzVerticalLines = 0;
        this.anzHorizontalLines = 0;
        this.anzRectangles = 0;

        this.matrices = [];
        this.horizontalLines = [];
        this.verticalLines = [];
        this.rectangles = [];
        this.rectangleColors = [];

        for (i = 0; i < 8; i += 1) {
            this.rectangles.push(new THREE.Vector4(0.0, 0.0, 0.0, 0.0));
            this.verticalLines.push(new THREE.Vector3(0.0, 0.0, 0.0));
            this.horizontalLines.push(new THREE.Vector3(0.0, 0.0, 0.0));
            this.matrices.push(new THREE.Matrix3());
            this.rectangleColors.push(1);
        }
    }
}